<template>
  <div
    v-if="packageSize"
    :class="{
      'product-package-size-fi': true,
      'product-package-size-fi--align-right': alignRight,
    }"
  >
    {{ $dict.get('online-Shop.Product.Unit-Description', [packageSize]) }}
  </div>
</template>

<script>
export default {
  name: 'ProductPackageSizeFi',
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    alignRight: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    packageSize() {
      if (!this.item || Object.keys(this.item).length === 0) {
        return null;
      }

      const stepRanges =
        this.item.bestPrice?.quantityStepRanges ||
        this.item.data?.quantityStepRanges ||
        this.item.data?.bestPrice.quantityStepRanges ||
        this.item?.quantityStepRanges;

      if (!stepRanges) {
        return null;
      }

      return stepRanges[0].rangeValue;
    },
  },
};
</script>

<style scoped lang="scss">
@import './product-package-size-fi';
</style>
